import clsx from "clsx"
import { Avatar } from "./"
import React, { FC } from "react"
import { AvatarSize } from "./Avatar/Avatar"

export type AvatarGroupItem = {
  initials: string
  src: string
}

interface Props {
  items: AvatarGroupItem[]
  itemClassName?: string
  tightness?: number
  borderWidth?: 1 | 2
  avatarSize?: AvatarSize
  avatarSizeNumber?: number
}

export const AvatarGroup: FC<Props> = ({
  items,
  itemClassName,
  tightness = 0.5,
  borderWidth = 2,
  avatarSize = "xs",
  avatarSizeNumber = 24,
}) => {
  const overlap = avatarSizeNumber * tightness + borderWidth

  return (
    <div className="flex flex-row">
      {items.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              marginLeft: index > 0 ? `-${overlap}px` : 0,
            }}
            className={clsx(
              "relative rounded-full border-bg-1",
              borderWidth === 1 ? "border" : "border-2",
              itemClassName
            )}>
            <Avatar size={avatarSize} initials={item.initials} src={item.src} />
          </div>
        )
      })}
    </div>
  )
}
